<script setup lang="ts">
import { Lock } from "@lucide/vue";
import { Button } from "@/components/ui/button";
import { t } from "@/copy/strings";
import EmptyState from "./EmptyState.vue";
</script>

<template>
  <EmptyState :icon="Lock" :title="t.errors.noAccessTitle" :description="t.errors.noAccessBody" class="mt-8">
    <Button as-child variant="outline"><RouterLink to="/">{{ t.nav.home }}</RouterLink></Button>
  </EmptyState>
</template>
